import { TransactionTitleText } from 'src/components/Global/Text/TitleText'
import { useTypedSelector } from 'src/redux/root-reducer'
import { TransactionInfoWrapper } from './transactionListInfoStyle'
import { SkeletonTransaction } from 'src/components/Global/Skeletons/TransactionSkeletons'
import { Link } from 'react-router-dom'
import NoPlan from 'src/components/GeneralSavings/WebTransaction/EmptyPlan/NoPlan'
import { TransactionArrow } from 'src/assets'
import {
  Savingsdebited,
  SavingsHome,
  TransactionImage,
  InvestmentHome,
  InterestHome,
} from 'src/assets'
const TransactionListinfo = () => {
  const transactionData = useTypedSelector(
    (state) =>
      state.transactionsReducer.transactionsResult.transactions?.transactions!
  )
  const transaction = transactionData?.slice(0, 4)

  const setDate = (item: any) => {
    let data = new Date(item.replace(/-/g, '/'))
    return data.toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  }

  const Status = (item: any) => {
    if (item === 'successful') {
      return 'successful'
    } else if (item === 'failed') {
      return 'failed'
    } else if (item === 'processing') {
      return 'processing'
    } else if (item === 'cancelled') {
      return 'cancelled'
    } else {
      return 'cancelled'
    }
  }
  const Image = (item: any) => {
    if (item === 'save') {
      return TransactionImage
    } else if (item === 'withdraw') {
      return Savingsdebited
    } else if (item === 'interest') {
      return InterestHome
    } else {
      return InvestmentHome
    }
  }
  const CheckStatus = (item: any) => {
    if (item === 'successful') {
      return 'para-successful'
    } else if (item === 'failed') {
      return 'para-failed'
    } else if (item === 'processing') {
      return 'para-processing'
    } else if (item === 'cancelled') {
      return 'para-cancelled'
    } else {
      return 'para-cancelled'
    }
  }
  const transactionLoading = useTypedSelector(
    (state) => state.transactionsReducer.loading
  )

  return (
    <TransactionInfoWrapper>
      {transactionLoading &&
        [1, 2, 3, 4].map((n) => <SkeletonTransaction key={n} theme="light" />)}

      {!transactionLoading && transaction == '' && (
        <NoPlan children="You have no transactions yet!!!" />
      )}

      {!transactionLoading && transaction !== [] && (
        <div>
          {transaction?.map((item: any) => (
            <div className="transactionHeadings lg">
              <div className="typelist">
                <p className="capitalize">
                  {item.type === 'save' ? 'savings' : item.type}
                </p>
              </div>
              <div className="amountlist">
                <p>{item.amount}</p>
              </div>
              <div className="datelist">
                <p>{`${setDate(item.date)}`}</p>
              </div>
              <div className="descriptionlist">
                <p className="transactionDesc">{item.description}</p>
                {/* <p>{item.description}</p> */}
              </div>
              <div className={`statuslist ${Status(item.status)}`}>
                <p className={`${CheckStatus(item.status)}`}>{item.status}</p>
              </div>
            </div>
          ))}
          {transaction?.map((item: any) => (
            <div key={item.id} className="transactionHeading mb">
              <div className="trans-flex">
                <div className="">
                  <img src={`${Image(item.type)}`} alt="" className="tranImg" />
                </div>
                <div className="">
                  {/* <h1 className="">{item.smallDescription}</h1> */}
                  <h3 className="type">
                    {item.type === 'save' ? 'savings' : item.type}
                  </h3>
                </div>
              </div>
              <div className="">
                <div className="">
                  <h3>{item.amount}</h3>
                </div>
                <div className="">
                  <h2>{`${setDate(item.date)}`}</h2>
                </div>
              </div>
            </div>
          ))}
          {transaction?.length >= 4 && (
            <Link to="/transactions" className="option-link">
              <TransactionTitleText className="tit">
                View more transactions{' '}
              </TransactionTitleText>
              <img src={TransactionArrow} alt="" className="arrow" />
            </Link>
          )}
        </div>
      )}
    </TransactionInfoWrapper>
  )
}

export { TransactionListinfo }
